<template>
	<div class="home">
		<van-nav-bar
		  	:title="$t('center.myintroPeople')"
		  	left-arrow
			  fixed
		  	@click-left="$router.go(-1)">
		</van-nav-bar>
		<div class="main">
			<van-cell size="large">
				<van-row slot="title">
				  	<van-col span="12">{{intro.account}}</van-col>
				  	<van-col class="tr" span="12">{{intro.name}}</van-col>
				</van-row>
				<van-row slot="label">
				  	<van-col span="24">{{intro.area_code}}{{intro.phone}}</van-col>
				</van-row>
			</van-cell>
		</div>
	</div>
</template>

<script>
export default {
    data () {
      	return {
      		intro:{}
      	}
    },
    mounted:function(){
    	this.getIntro();
    },
    methods:{
    	getIntro(){
    		this.$axios({
                method: 'get',
                headers: {
                    "Authorization": 'Bearer '+sessionStorage.token,
                },
                url: this.$build+'/api/user/online',
            }).then(res => {
            	console.log(res);
            	if(res.data.status==200){
            		this.intro=res.data.data;
            	}else{
            		this.$toast.allowMultiple();
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
                this.$toast({
            		type:'fail',
            		message:this.$t('center.message'),
        		});
            });
    	},
    }
}
</script>
<style scoped>
	.home{
		width: 100%;
		height: 100vh;
	}
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/.van-cell__label{
		color: #000;
	}
	.tr{
		text-align: right;
	}
</style>



// WEBPACK FOOTER //
// src/Person/MyIntro.vue